export const appThemes = [
  { theme: "theme-bg-dark", name: "Dark" },
  { theme: "theme-bg-light", name: "Light" },
  { theme: "theme-bg-indigo", name: "Indigo" },
  { theme: "theme-bg-dynamic", name: "Dynamic" },
];
export const appColors = [
  { theme: "theme-red", name: "Red" },
  { theme: "theme-orange", name: "Orange" },
  { theme: "theme-amber", name: "Amber" },
  { theme: "theme-yellow", name: "Yellow" },
  { theme: "theme-lime", name: "Lime" },
  { theme: "theme-green", name: "Green" },
  { theme: "theme-emerald", name: "Emerald" },
  { theme: "theme-teal", name: "Teal" },
  { theme: "theme-cyan", name: "Cyan" },
  { theme: "theme-lightBlue", name: "Light Blue" },
  { theme: "theme-blue", name: "Blue" },
  { theme: "theme-indigo", name: "Indigo" },
  { theme: "theme-violet", name: "Violet" },
  { theme: "theme-purple", name: "Purple" },
  { theme: "theme-fuchsia", name: "Fuchsia" },
  { theme: "theme-pink", name: "Pink" },
  { theme: "theme-rose", name: "Rose" },
  { theme: "theme-dark", name: "Dark" },
  { theme: "theme-gray", name: "Gray" },
  { theme: "theme-blueGray", name: "Blue Gray" },
  { theme: "theme-coolGray", name: "Cool Gray" },
  { theme: "theme-trueGray", name: "True Gray" },
  { theme: "theme-warmGray", name: "Warm Gray" },
];
